module.exports = __webpack_public_path__ + "img/hedgehog.00141d8a.png";